import React from "react";
import MarcoPolo1 from "../assets/images/vatel/marco-polo1.jpg";
import MarcoPolo2 from "../assets/images/vatel/marco-polo2.jpg";
import MarcoPolo3 from "../assets/images/vatel/marco-polo3.jpg";
import MarcoPolo4 from "../assets/images/vatel/marco-polo4.jpg";
import {useSmoothScrollContext} from "../context/SmoothScrollContext"

const OpportunitesInternationales = () => {
    const { handleLinkClick } = useSmoothScrollContext();
  return (
      <div className="EmbedForm-area section-padding bg-cover">
          <div className="container">
              <div className="text-center">
                  <div className="mini-title">S'ouvrir au monde pour réussir</div>
                  <div className="column-title tw-max-w-3xl tw-mx-auto">
                      Opportunités <span className={'shape-bg'}>internationales</span>
                  </div>
              </div>
              <div className="pt-10 text-center">
                  <p>Marco Polo, c’est le programme qui permet aux étudiants qui suivent la formation Vatel en initial
                      de poursuivre en 2e année voire 3e année de Bachelor dans une autre école Vatel.</p>
                  <p>C’est une formidable opportunité pour s’ouvrir, découvrir un pays, une culture, un système
                      d’enseignement… et maîtriser une langue étrangère, tout en poursuivant très sérieusement son
                      cursus.</p>
              </div>
              <div className="tw-container tw-mx-auto tw-px-4 tw-py-8">
                  <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-6">
                      {/* Photo 1 */}
                      <div className="tw-group tw-relative tw-overflow-hidden tw-rounded-xl tw-shadow-lg">
                          <div className="tw-aspect-w-4 tw-aspect-h-3">
                              <img
                                  src={MarcoPolo1}
                                  alt="Description 1"
                                  className="tw-w-full tw-h-full tw-object-cover tw-transform tw-transition-transform duration-300 group-hover:tw-scale-110"
                              />
                              <div
                                  className="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-0 tw-group-hover:tw-bg-opacity-50 tw-transition-all tw-duration-300">
                                  <div
                                      className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-opacity-0 tw-group-hover:tw-opacity-100 tw-transition-opacity tw-duration-300">
                                      <p className="tw-text-white tw-text-lg tw-font-medium">Photo 1</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                      {/* Photo 2 */}
                      <div className="tw-group tw-relative tw-overflow-hidden tw-rounded-xl tw-shadow-lg">
                          <div className="tw-aspect-w-4 tw-aspect-h-3">
                              <img
                                  src={MarcoPolo2}
                                  alt="Description 2"
                                  className="tw-w-full tw-h-full tw-object-cover tw-transform tw-transition-transform duration-300 group-hover:tw-scale-110"
                              />
                              <div
                                  className="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-0 tw-group-hover:tw-bg-opacity-50 tw-transition-all tw-duration-300">
                                  <div
                                      className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-opacity-0 tw-group-hover:tw-opacity-100 tw-transition-opacity tw-duration-300">
                                      <p className="tw-text-white tw-text-lg tw-font-medium">Photo 2</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                      {/* Photo 3 */}
                      <div className="tw-group tw-relative tw-overflow-hidden tw-rounded-xl tw-shadow-lg">
                          <div className="tw-aspect-w-4 tw-aspect-h-3">
                              <img
                                  src={MarcoPolo3}
                                  alt="Description 3"
                                  className="tw-w-full tw-h-full tw-object-cover tw-transform tw-transition-transform duration-300 group-hover:tw-scale-110"
                              />
                              <div
                                  className="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-0 tw-group-hover:tw-bg-opacity-50 tw-transition-all tw-duration-300">
                                  <div
                                      className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-opacity-0 tw-group-hover:tw-opacity-100 tw-transition-opacity tw-duration-300">
                                      <p className="tw-text-white tw-text-lg tw-font-medium">Photo 3</p>
                                  </div>
                              </div>
                          </div>
                      </div>

                      {/* Photo 4 */}
                      <div className="tw-group tw-relative tw-overflow-hidden tw-rounded-xl tw-shadow-lg">
                          <div className="tw-aspect-w-4 tw-aspect-h-3">
                              <img
                                  src={MarcoPolo4}
                                  alt="Description 4"
                                  className="tw-w-full tw-h-full tw-object-cover tw-transform tw-transition-transform duration-300 group-hover:tw-scale-110"
                              />
                              <div
                                  className="tw-absolute tw-inset-0 tw-bg-black tw-bg-opacity-0 tw-group-hover:tw-bg-opacity-50 tw-transition-all tw-duration-300">
                                  <div
                                      className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-opacity-0 tw-group-hover:tw-opacity-100 tw-transition-opacity tw-duration-300">
                                      <p className="tw-text-white tw-text-lg tw-font-medium">Photo 4</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div className="pt-8 text-center">
                  <a
                      href="#brochure"
                      className="btn btn-primary text-center"
                      onClick={(e) => handleLinkClick(e, 'brochure')}>
                      Découvrir nos opportunités internationales
                  </a>
              </div>
          </div>
      </div>
  );
};

export default OpportunitesInternationales;
